var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"sort-options":{
      enabled: true,
    },"styleClass":"vgt-table bordered","pagination-options":{
      enabled: true,
      mode: 'registros',
      position: 'top',
      perPage: 15,
      nextLabel: 'siguiente',
      prevLabel: 'anterior',
      rowsPerPageLabel: 'Filas por página',
      ofLabel: 'de',
      pageLabel: 'páginas', // for 'pages' mode
      allLabel: 'Todos',
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }